import _ from 'lodash';
import familyExpansion from '@/constants/familyExpansion';
import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { useUserPermission } from '@/presentation/composables/user/use-user-permission';
import { useFolderSetting } from '@/presentation/pages/workspace-detail/composables/use-folder-setting';
export const name = 'SORT_SEQ_NUM.render';
function renderDefault(h, renderOpts, params) {
    const { row, column, visibleData, rowIndex } = params;
    const rowData = _.get(visibleData, rowIndex, {});
    const prop = _.get(column, 'property');
    const cellValue = _.get(row, prop);
    const { currentSort } = useFolderSetting();
    const detailService = injectService(DetailServiceSymbol);
    const collapseField = _.get(detailService, 'viewData.collapse_setting.collapse.field');
    const family = familyExpansion.getFamilyId(collapseField);
    const mode = family || familyExpansion.sort2Mode(currentSort.value);
    const { userPermission } = useUserPermission();
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {family && userPermission.value.family_search
                ? <a class="text-grey-450" target="_blank" data-link-type="FAMILY" data-link-data={rowData.PN} data-patent-id={rowData.PATENT_ID} data-patent-no={rowData.PN} data-bio-uk={rowData.BIO_UK[0]} 
                // @ts-ignore
                domPropsInnerHTML={`${this.$t(`folder.familyExpansion.shortType.${family}`)} ${cellValue}`}>
                </a>
                : <span class="text-grey-450" 
                // @ts-ignore
                domPropsInnerHTML={`${this.$t(`folder.familyExpansion.shortType.${mode}`)} ${cellValue}`}>
                </span>}
        </div>,
    ];
}
function exportMethod(params) {
    const i18n = injectService(i18nSymbol);
    const { currentSort } = useFolderSetting();
    const mode = familyExpansion.sort2Mode(currentSort.value);
    const { row, column } = params;
    return `${i18n.t(`folder.familyExpansion.shortType.${mode}`)} ${row[column.property]}`;
}
export default {
    renderDefault,
    exportMethod,
};
